export enum ServicesActionTypes {
  SERVICE_ID_SET = "SERVICES/SET_ID",
  SERVICES_LIST_SET = "SERVICES/SET_LIST",
  ADD_SERVICE = "SERVICES/ADD_SERVICE",
  ADD_SERVICE_SUCCESS = "SERVICES/ADD_SERVICE_SUCCESS",
  SERVICE_DETAILS_SET = "SERVICES/DETAILS_SET",
  LINK_SERVICES = "SERVICES/LINK_SERVICES",
  SERVICE_STEPS_SET = "SERVICES/STEPS_SET",
  EDIT_SERVICE = "SERVICES/EDIT_SERVICE",
  SET_SERVICE_LIST_LOADING = "SERVICES/SET_SERVICE_LIST_LOADING",
  SET_SERVICE_UPDATE_SUCCESSFUL = "SERVICES/SET_SERVICE_UPDATE_SUCCESSFUL",
  CHANGE_ACTIVE_TAB = "SERVICES/CHANGE_ACTIVE_TAB",
  VIEW_ATTACHMENTS_STATE = "SERVICES/ATTACHMENTS_STATE_VIEW",
  CLOSE_VIEW_ATTACHMENTS_STATE = "SERVICES/CLOSE_ATTACHMENTS_STATE_VIEW",
  SET_NUM_PAGES = "SERVICES/SET_NUM_PAGES",
  SET_UPLOADED_FINISH = "SERVICES/SET_UPLOADED_FINISH",

  FETCH_NEW_RECORDS_COUNT_REQUEST = "SERVICES/FETCH_NEW_RECORDS_COUNT_REQUEST",
  FETCH_NEW_RECORDS_COUNT_SUCCESS = "SERVICES/FETCH_NEW_RECORDS_COUNT_SUCCESS",
  FETCH_NEW_RECORDS_COUNT_FAILURE = "SERVICES/FETCH_NEW_RECORDS_COUNT_FAILURE",

  FETCH_ANALYZE_NEW_COUNT_SUCCESS = "SERVICES/FETCH_ANALYZE_NEW_COUNT_SUCCESS",

  GET_SERVICE_WITH_DOCS_REQUEST = "SERVICES/GET_SERVICE_WITH_DOCS_REQUEST",
  GET_SERVICE_WITH_DOCS_SUCCESS = "SERVICES/GET_SERVICE_WITH_DOCS_SUCCESS",
  GET_SERVICE_WITH_DOCS_FAILURE = "SERVICES/GET_SERVICE_WITH_DOCS_FAILURE",

  FETCH_WITHOUT_ANALYZE_COUNT_SUCCESS = "SERVICES/FETCHWITHOUT_ANALYZE_COUNT_SUCCESS",

  SKIP_FIRST_RECORD_RESET = "SERVICES/SKIP_FIRST_RECORD_RESET",
  CLEAR_FIRST_RECORD_RESET = "SERVICES/CLEAR_FIRST_RECORD_RESET",

  SET_LAST_TAB = "SET_LAST_TAB",
  SET_REGISTER_ITEM_TYPE_KINDS_LOADING = "SET_REGISTER_ITEM_TYPE_KINDS_LOADING",
  REGISTER_ITEM_TYPE_KINDS_SET = "REGISTER_ITEM_TYPE_KINDS_SET",
  UPDATE_REGISTER_ITEM_TYPE_KIND_SUCCESS = "UPDATE_REGISTER_ITEM_TYPE_KIND_SUCCESS",
  UPDATE_REGISTER_ITEM_TYPE_KIND_FAILURE = "UPDATE_REGISTER_ITEM_TYPE_KIND_FAILURE",
}
